import React from 'react'
import { BuildPath } from '../../helpers/Paths';
import { UserUploadActionProgress } from '../../models/ApiResponseModels/UserUploadActionProgressModel';
import Details from '../elements/userupload/Details'
import ModalWrapper from './ModalWrapper'

interface UploadDetailsModalProps {
    isDetailsOpen: boolean
    SetDetailsModal: (value: boolean) => void
    progressReport: UserUploadActionProgress
}

const UploadDetailsModal = ({isDetailsOpen, SetDetailsModal, progressReport}:UploadDetailsModalProps) => (
    <ModalWrapper className="user-upload-modal" isOpen={isDetailsOpen} escClose={true} onRequestClose={() => SetDetailsModal(false)}>      
                    
        <h2>Upload details</h2>
        {progressReport && progressReport.UserComparisonReport
            ? <Details 
                userComparisonReport={progressReport.UserComparisonReport}
                userImportId={progressReport.UserImportId}
            />
            : <div className="upload-processing">
                <img alt='Processing' src={`${BuildPath()}/images/userupload/Rolling.svg`}/>
                <p> Fetching your upload details </p>
            </div>
        }
        

        <div className="upload-nav">
            <button className="user-upload-btn-clear btn" onClick={() => SetDetailsModal(false)}>Close</button>
        </div>

    </ModalWrapper>   
);

export default UploadDetailsModal;